import { Component, EventEmitter, Output } from '@angular/core';
import { QuadroCompensiParcella } from '../../../models/quadro-compensi-parcella';
import { FaseCompensoParcella } from '../../../models/tipologiche/fase-compenso-parcella';
import { ValoriRiferimentoParcella } from '../../../models/valori-riferimento-parcella';
import { NumericOperationManager } from '../../../utils/numeric-operation-manager';
import { ParcellaAbstractForm } from '../parcella-abstract-forn';

declare var $: any;

@Component({
    selector: 'div [parcella-giudiziale-quadro-form]',
  templateUrl: 'parcella-giudiziale-quadro-form.html',
  host: {}
})

export class ParcellaGiudizialeQuadroForm extends ParcellaAbstractForm {
  @Output() onReturn: EventEmitter<QuadroCompensiParcella[]> = new EventEmitter<QuadroCompensiParcella[]>();
  valoriRiferimentoParcella: ValoriRiferimentoParcella[];
  fasiCompensi: FaseCompensoParcella[];

  // quadro compensi
  fasicheckedAll: boolean = false;
  mincheckedAll: boolean = false;
  medcheckedAll: boolean = false;
  maxcheckedAll: boolean = false;
  minNameRadio: string = 'mincheckaddId';
  medNameRadio: string = 'medcheckaddId';
  maxNameRadio: string = 'maxcheckaddId';
  idImporto: string = 'importoFase';
  nameRadio: string = 'minmedmaxcheckadd';
  quadroPreCompilato: boolean = false;

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

  resetQuadroCompensi() {
    this.fasicheckedAll = false;
    this.mincheckedAll = false;
    this.medcheckedAll = false;
    this.maxcheckedAll = false;
    this.quadroCompensiGrid = [];
  }

  createQuadroCompensi() {
    this.quadroPreCompilato = false;
    this.resetQuadroCompensi();
    console.log(this.valoriRiferimentoParcella);
    let importoDefault = 0;
    for (let vrp of this.valoriRiferimentoParcella) {
      let quadro = new QuadroCompensiParcella();
      let id = vrp.id;
      quadro.fase = vrp.fase;
      quadro.idImporto = this.idImporto + id;
      quadro.idFase = vrp.fase.id;
      quadro.idRadioMin = this.minNameRadio + vrp.id + '-' + Math.random();
      quadro.idRadioMed = this.medNameRadio + vrp.id + '-' + Math.random();
      quadro.idRadioMax = this.maxNameRadio + vrp.id + '-' + Math.random();
      quadro.nameRadio = this.nameRadio + id + '-' + Math.random();
      quadro.valoreMinimo = vrp.valoreMinimo;
      quadro.valoreMedio = vrp.valoreMedio;
      quadro.valoreMassimo = vrp.valoreMassimo;
      importoDefault = quadro.valoreMedio;
      let result = $.grep(this.fasiCompensi, function(e: any) { return e.fase.id === quadro.idFase; });
      if (result.length > 0) {
        quadro.idFase = result[0].id;
        quadro.checkedFase = true;
        importoDefault = result[0].compenso;
        quadro.disabledMin = false;
        quadro.disabledMed = false;
        quadro.disabledMax = false;
        this.quadroPreCompilato = true;
        if (importoDefault === vrp.valoreMinimo) {
          quadro.checkedMin = true;
        } else {
          quadro.checkedMin = false;
        }
        if (importoDefault === vrp.valoreMedio) {
          quadro.checkedMed = true;
        } else {
          quadro.checkedMed = false;
        }
        if (importoDefault === vrp.valoreMassimo) {
          quadro.checkedMax = true;
        } else {
          quadro.checkedMax = false;
        }
      } else {
        quadro.checkedFase = false;
        quadro.disabledMin = true;
        quadro.disabledMed = true;
        quadro.disabledMax = true;
      }
      quadro.idCheckboxFase = quadro.idFase + '-' + this.quadroPreCompilato;
      quadro.compenso = importoDefault;
      quadro.valoreMedio = quadro.valoreMedio.toFixed(2).toString().replace('.', ',');
      quadro.valoreMinimo = quadro.valoreMinimo.toFixed(2).toString().replace('.', ',');
      quadro.valoreMassimo = quadro.valoreMassimo.toFixed(2).toString().replace('.', ',');
      quadro.compenso = quadro.compenso.toString().replace('.', ',');

      this.quadroCompensiGrid.push(quadro);
    }
    this.onReturn.emit(this.quadroCompensiGrid);
    // opzioni di default
    if (!this.quadroPreCompilato) {
      this.setFase(); // seleziono tutte le fasi
      //      this.setMed(); // seleziono tutti gli importi medi
    } else {
      this.setFasePrecompilato();
    }
  }

  setFase() {
    this.fasicheckedAll = !this.fasicheckedAll;
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedFase = this.fasicheckedAll;
      this.quadroCompensiGrid[i] = q;
      i++;
    }
    if (this.fasicheckedAll === false) {
      this.mincheckedAll = false;
      this.medcheckedAll = false;
      this.maxcheckedAll = false;
      this.disabledRadio();
    } else {
      this.abilitaRadio();
      this.setMed();
    }
  }

  setFasePrecompilato() {
    this.fasicheckedAll = false;
    let i = 0;
    let checkedCounter = 0;
    let checkedCounterMin = 0;
    let checkedCounterMed = 0;
    let checkedCounterMax = 0;
    for (let q of this.quadroCompensiGrid) {
      if (q.checkedFase) {
        checkedCounter++;
      }
      if (q.checkedMin) {
        checkedCounterMin++;
      }
      if (q.checkedMed) {
        checkedCounterMed++;
      }
      if (q.checkedMax) {
        checkedCounterMax++;
      }
      i++;
    }
    if (i === checkedCounter) {
      this.fasicheckedAll = true;
    }
    if (i === checkedCounterMin) {
      this.mincheckedAll = true;
    }
    if (i === checkedCounterMed) {
      this.medcheckedAll = true;
    }
    if (i === checkedCounterMax) {
      this.maxcheckedAll = true;
    }
  }

  setMin() {
    this.mincheckedAll = !this.mincheckedAll;
    this.medcheckedAll = false;
    this.maxcheckedAll = false;
    this.refreshMin();
  }

  refreshMin() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedMed = false;
      q.checkedMax = false;
      if (q.checkedMin) {
        q.compenso = '0';
      }

      if (this.mincheckedAll === true) {
        q.checkedMin = q.checkedFase;
      } else {
        q.checkedMin = false;
      }

      if (q.checkedMin) {
        q.compenso = q.valoreMinimo;
      }
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  setMed() {
    this.medcheckedAll = !this.medcheckedAll;
    this.mincheckedAll = false;
    this.maxcheckedAll = false;
    this.refreshMed();
  }

  refreshMed() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedMin = false;
      q.checkedMax = false;
      if (q.checkedMed) {
        q.compenso = '0';
      }

      if (this.medcheckedAll === true) {
        q.checkedMed = q.checkedFase;
      } else {
        q.checkedMed = false;
      }

      if (q.checkedMed) {
        q.compenso = q.valoreMedio;
      }
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  setMax() {
    this.maxcheckedAll = !this.maxcheckedAll;
    this.mincheckedAll = false;
    this.medcheckedAll = false;
    this.refreshMax();
  }

  refreshMax() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedMin = false;
      q.checkedMed = false;
      if (q.checkedMax) {
        q.compenso = '0';
      }

      if (this.maxcheckedAll === true) {
        q.checkedMax = q.checkedFase;
      } else {
        q.checkedMax = false;
      }

      if (q.checkedMax) {
        q.compenso = q.valoreMassimo;
      }
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  gstRadio(id: string, isFaseChecked: boolean) {
    let ind = this.quadroCompensiGrid.findIndex(q => q.fase.id === id);
    this.quadroCompensiGrid[ind].checkedFase = isFaseChecked;
    if (!isFaseChecked) {
      this.quadroCompensiGrid[ind].checkedMin = false;
      this.quadroCompensiGrid[ind].checkedMed = false;
      this.quadroCompensiGrid[ind].checkedMax = false;
      this.quadroCompensiGrid[ind].compenso = '0';
    }
    this.quadroCompensiGrid[ind].disabledMin = !isFaseChecked;
    this.quadroCompensiGrid[ind].disabledMed = !isFaseChecked;
    this.quadroCompensiGrid[ind].disabledMax = !isFaseChecked;
    if (isFaseChecked) {
      this.quadroCompensiGrid[ind].checkedMed = false;
      this.settaImportoFase(this.quadroCompensiGrid[ind].fase.id, this.quadroCompensiGrid[ind].valoreMedio, 1, false);
    }
    if (!this.checkAtLeastOneFase()) {
      this.fasicheckedAll = false;
      this.mincheckedAll = false;
      this.medcheckedAll = false;
      this.maxcheckedAll = false;
      this.disableAllChecked();
    }
    console.log('');
  }

  disableAllChecked() {
    for (let q of this.quadroCompensiGrid) {
      q.checkedMin = false;
      q.checkedMax = false;
      q.checkedMed = false;
    }
  }

  disabledRadio() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedMin = false;
      q.checkedMed = false;
      q.checkedMax = false;
      this.quadroCompensiGrid[i] = q;
      q.disabledMin = true;
      q.disabledMed = true;
      q.disabledMax = true;
      q.compenso = '0';
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  abilitaRadio() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.disabledMin = false;
      q.disabledMed = false;
      q.disabledMax = false;
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  settaImportoFase(id: string, importo: string, faseType: number, checked: boolean) {
    if (!checked) {
      this.mincheckedAll = false;
      this.medcheckedAll = false;
      this.maxcheckedAll = false;
      let ind = this.quadroCompensiGrid.findIndex(q => q.fase.id === id);
      this.quadroCompensiGrid[ind].compenso = importo;
      if (faseType === 0 && !this.quadroCompensiGrid[ind].checkedMin) {
        this.quadroCompensiGrid[ind].checkedMin = true;
      } else {
        this.quadroCompensiGrid[ind].checkedMin = false;
      }
      if (faseType === 1 && !this.quadroCompensiGrid[ind].checkedMed) {
        this.quadroCompensiGrid[ind].checkedMed = true;
      } else {
        this.quadroCompensiGrid[ind].checkedMed = false;
      }
      if (faseType === 2 && !this.quadroCompensiGrid[ind].checkedMax) {
        this.quadroCompensiGrid[ind].checkedMax = true;
      } else {
        this.quadroCompensiGrid[ind].checkedMax = false;
      }
    }
  }

  disableRadio(q: QuadroCompensiParcella) {
    if (q.checkedMin) {
      q.checkedMin = false;
    }
    if (q.checkedMed) {
      q.checkedMed = false;
    }
    if (q.checkedMax) {
      q.checkedMax = false;
    }
  }

  ricalcolaTotale(): string {
    let importi: string[] = [];
    for (let q of this.quadroCompensiGrid) {
      if (q.checkedFase) {
        importi.push(q.compenso ? q.compenso : '0');
      }
    }
    let totale = NumericOperationManager.getSum(importi);
    this.onReturn.emit(this.quadroCompensiGrid);
    return NumericOperationManager.transformToThousands(String(totale));
  }

  validate(event: any, _value: string) {
    let theEvent = event || window.event;
    let key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    // var regex = /^[0-9]+(\,{1}[0-9]{1,2}){0,1}$/g;
    // var regex = /[0-9]|\/[^,]*/; // per inserire numeri e virgole
    // var regex = /[0-9]|\,/; // per inserire numeri e virgole OK (per� puoi inserire tante virgole)
    let regex = /^[0-9]+\,{0,1}([0-9]{1,}){0,1}$/g;
    let value = _value;
    if (!value) {
      value = '';
    }
    if (!regex.test(value + key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  validateChange(q: QuadroCompensiParcella) {
    // var regex = /^[0-9]+(\,{1}[0-9]{1,2}){0,1}$/g;
    // var regex = /[0-9]|\/[^,]*/; // per inserire numeri e virgole
    // var regex = /[0-9]|\,/; // per inserire numeri e virgole OK (per� puoi inserire tante virgole)
    let regex = /^[0-9]+\,{0,1}([0-9]{1,}){0,1}$/g;
    let value = q.compenso;
    if (!value) {
      value = '';
    }
    if (!regex.test(value)) {
      q.compenso = '';
    }
  }

}
